var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconaweSomeBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.94,
    height: 18.217,
    viewBox: "0 0 15.94 18.217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-bell",
    "data-name": "Icon awesome-bell",
    d: "M7.97,18.217a2.277,2.277,0,0,0,2.276-2.277H5.694A2.277,2.277,0,0,0,7.97,18.217Zm7.664-5.327c-.687-.739-1.974-1.85-1.974-5.49A5.619,5.619,0,0,0,9.108,1.88V1.139a1.138,1.138,0,1,0-2.276,0V1.88A5.619,5.619,0,0,0,2.28,7.4c0,3.64-1.286,4.751-1.974,5.49A1.112,1.112,0,0,0,0,13.663,1.14,1.14,0,0,0,1.142,14.8H14.8a1.139,1.139,0,0,0,1.142-1.139,1.111,1.111,0,0,0-.306-.772Z",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaweSomeBell);
export default __webpack_public_path__ + "static/media/IconaweSomeBell.e47a32511bef3b2047275791ea1b8359.svg";
export { ForwardRef as ReactComponent };